import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../../theme/theme";
import {
  FacebookOutlined,
  Instagram,
  Twitter,
  YouTube,
} from "@mui/icons-material";

const ProfileLeftPanel = ({ user }) => {
  const socialProfiles =
    user?.facebook_url ||
    user?.instagram_url ||
    user?.youtube_url ||
    user?.twitter_url;

  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
    >
      <Box
        sx={{
          mx: 2,
          pt: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid rgba(25,34,52,0.09)",
          pb: 2,
        }}
      >
        <img
          src={user?.avatar || require("../../../assets/images/default.jpg")}
          alt="avatar"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "360px",
            objectFit: "cover",
            marginBottom: "10px",
          }}
        />
        <Typography
          sx={{
            color: colors.primary,
            fontFamily: "Mulish-Bold",
            fontSize: "20px",
          }}
        >
          {user?.firstName + " " + user?.lastName}
        </Typography>

        <Typography
          sx={{
            color: colors.secondary,
            fontFamily: "Mulish-Medium",
            fontSize: "16px",
          }}
        >
          NYC, USA
        </Typography>
      </Box>

      <Box
        sx={{
          mx: 2,
          my: 1,
          borderBottom: "1px solid rgba(25,34,52,0.09)",
          pb: 2,
        }}
      >
        <Typography
          sx={{
            color: colors.primary,
            fontFamily: "Mulish-Bold",
            fontSize: "16px",
          }}
        >
          About Me
        </Typography>
        <Typography
          sx={{
            color: "rgba(25,34,52,0.68)",
            fontFamily: "Mulish-Medium",
            fontSize: "14px",
            mt: 1,
          }}
        >
          {user?.bio || ""}
        </Typography>
      </Box>

      {socialProfiles && (
        <Box
          sx={{
            mx: 2,
            my: 1,
            borderBottom: "1px solid rgba(25,34,52,0.09)",
            pb: 2,
            overflow: "hidden",
          }}
        >
          <Typography
            sx={{
              color: colors.primary,
              fontFamily: "Mulish-Bold",
              fontSize: "16px",
            }}
          >
            Social Profile
          </Typography>

          {user?.facebook_url && (
            <Stack direction={"row"} spacing={1} mt={2} alignItems={"center"}>
              <FacebookOutlined
                sx={{ color: "rgba(25,34,52, 0.77)", fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "14px",
                }}
              >
                {user?.facebook_url}
              </Typography>
            </Stack>
          )}
          {user?.instagram_url && (
            <Stack direction={"row"} spacing={1} mt={2} alignItems={"center"}>
              <Instagram
                sx={{ color: "rgba(25,34,52, 0.77)", fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "14px",
                }}
              >
                {user?.instagram_url}
              </Typography>
            </Stack>
          )}
          {user?.youtube_url && (
            <Stack direction={"row"} spacing={1} mt={2} alignItems={"center"}>
              <YouTube
                sx={{ color: "rgba(25,34,52, 0.77)", fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "14px",
                }}
              >
                {user?.youtube_url}
              </Typography>
            </Stack>
          )}
          {user?.twitter_url && (
            <Stack direction={"row"} spacing={1} mt={2} alignItems={"center"}>
              <Twitter
                sx={{ color: "rgba(25,34,52, 0.77)", fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "14px",
                }}
              >
                {user?.twitter_url}
              </Typography>
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ProfileLeftPanel;
